import { SxProps, Theme } from '@mui/material';
import { inclusiveGray } from 'shared/utils/inclusiveColors';

const inspectionPreviewCardBaseSx = {
  minWidth: 320,
  maxWidth: 420,
  borderRadius: 2,
  backgroundColor: inclusiveGray[50],
} as const satisfies SxProps<Theme>;

export const inspectionPreviewCardSx = {
  base: inspectionPreviewCardBaseSx,
  loading: {
    ...inspectionPreviewCardBaseSx,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
  },
  error: {
    ...inspectionPreviewCardBaseSx,
    p: 2,
  },
} as const satisfies Record<string, SxProps<Theme>>;
